import { fromJS } from 'immutable';

import {
  LOAD_ANALYTICS_ASSET_LIST,
  LOAD_ANALYTICS_ASSET_LIST_ERROR,
  LOAD_ANALYTICS_ASSET_LIST_SUCCESS,
  UPDATE_ANALYTICS_ASSET_LIST,
  ADD_TRACKED_ASSET_TO_LIST,
  GET_NEW_ASSET_ERROR,
} from './constants';

const initialState = fromJS({
  youtubeVideos: {},
  filteredYoutubeVideos: {},
  instagramPosts: {},
  filteredInstagramPosts: {},
  facebookPosts: {},
  filteredFacebookPosts: {},
  twitterPosts: {},
  filteredTwitterPosts: {},
  campaignVideos: {},
  userVideos: {},
  filterByOptions: [],
  hasTrackedDeliverables: false,
  loading: false,
  error: null,
  sortBy: 'highestViews',
  filterBy: 'allVideos',
  showAnalyticTotals: false,
  youtubeTotals: {},
  instagramTotals: {},
  facebookTotals: {},
});

function analyticsAssetListReducer(state = initialState, action) {
  switch (action.type) {
  case LOAD_ANALYTICS_ASSET_LIST:
    return state
      .set('youtubeVideos', fromJS({}))
      .set('filteredYoutubeVideos', fromJS({}))
      .set('instagramPosts', fromJS({}))
      .set('filteredInstagramPosts', fromJS({}))
      .set('facebookPosts', fromJS({}))
      .set('filteredFacebookPosts', fromJS({}))
      .set('twitterPosts', fromJS({}))
      .set('filteredTwitterPosts', fromJS({}))
      .set('hasTrackedDeliverables', false)
      .set('loading', true)
      .set('error', null);
  case LOAD_ANALYTICS_ASSET_LIST_SUCCESS:
    return state
      .set('youtubeVideos', action.youtubeVideos)
      .set('filteredYoutubeVideos', action.youtubeVideos)
      .set('instagramPosts', action.instagramPosts)
      .set('filteredInstagramPosts', action.instagramPosts)
      .set('facebookPosts', action.facebookPosts)
      .set('filteredFacebookPosts', action.facebookPosts)
      .set('twitterPosts', action.twitterPosts)
      .set('filteredTwitterPosts', action.twitterPosts)
      .set('userVideos', action.userVideos)
      .set('campaignVideos', action.campaignVideos)
      .set('filterByOptions', action.filterByOptions)
      .set('hasTrackedDeliverables', action.hasTrackedDeliverables)
      .set('loading', false)
      .set('error', null);
  case LOAD_ANALYTICS_ASSET_LIST_ERROR:
    return state
      .set('loading', false)
      .set('error', action.error);
  case UPDATE_ANALYTICS_ASSET_LIST:
    return state
      .set('filteredYoutubeVideos', action.filteredYoutubeVideos)
      .set('filteredInstagramPosts', action.filteredInstagramPosts)
      .set('filteredFacebookPosts', action.filteredFacebookPosts)
      .set('filteredTwitterPosts', action.filteredTwitterPosts)
      .set('hasTrackedDeliverables', true)
      .set('sortBy', action.sortBy)
      .set('filterBy', action.filterBy)
      .set('showAnalyticTotals', action.showAnalyticTotals)
      .set('youtubeTotals', action.youtubeTotals)
      .set('instagramTotals', action.instagramTotals)
      .set('facebookTotals', action.facebookTotals);
  case ADD_TRACKED_ASSET_TO_LIST: {
    let updatedState;
    if (!state.getIn([action.assetList, action.assetId])) updatedState = state.setIn([action.assetList, action.assetId], action.newAsset);
    return updatedState
      .setIn(['userVideos', action.assetId], action.newAsset)
      .set('sortBy', initialState.get('sortBy'))
      .set('filterBy', initialState.get('filterBy'));
  }
  case GET_NEW_ASSET_ERROR:
    return state
      .set('error', action.error)
      .set('loading', false);
  default:
    return state;
  }
}

export default analyticsAssetListReducer;



/** WEBPACK FOOTER **
 ** ./src/containers/analytics-asset-list/reducer.js
 **/